import { useEffect, useState } from "react";
import API from "../../../../services/api";

const useAnalytics = () => {
  const [dashboard, setDashboard] = useState({});
  const [revenue, setRevenue] = useState([]);
  const [topFoods, setTopFoods] = useState([]);
  const [categories, setCategories] = useState([]);
  const [customers, setCustomers] = useState({});
  const [peakHours, setPeakHours] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadData = async () => {
    try {
      setLoading(true);

      const [
        dashboardRes,
        revenueRes,
        foodsRes,
        categoryRes,
        customerRes,
        peakHourRes,
      ] = await Promise.all([
        API.get("/analytics/dashboard"),
        API.get("/analytics/revenue"),
        API.get("/analytics/top-foods"),
        API.get("/analytics/categories"),
        API.get("/analytics/customers"),
        API.get("/analytics/peak-hours"),
      ]);

      setDashboard(dashboardRes.data);

      setRevenue(revenueRes.data.revenue || []);

      setTopFoods(foodsRes.data.foods || []);

      setCategories(categoryRes.data.categories || []);

      setCustomers(customerRes.data);

      setPeakHours(peakHourRes.data.peakHours || []);
    } catch (err) {
      console.log(err);

      setError(
        err.response?.data?.message ||
          "Failed to load analytics."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return {
    dashboard,
    revenue,
    topFoods,
    categories,
    customers,
    peakHours,
    loading,
    error,
    refresh: loadData,
  };
};

export default useAnalytics;